import React, { useState } from 'react';
import './Organ.css';

const organs = [
  { name: 'Heart', image: '/images/c1.jpg', description: 'Pumps blood throughout the body.' },
  { name: 'Brain', image: '/images/brain.png', description: 'Controls thoughts, memory, and other functions.' },
  { name: 'Lungs', image: '/images/lungs.png', description: 'Helps you breathe by taking in oxygen and expelling carbon dioxide.' },
  { name: 'Stomach', image: '/images/stomach.png', description: 'Breaks down food for digestion.' },
  { name: 'Liver', image: '/images/liver.png', description: 'Processes nutrients and detoxifies the body.' },
];

const Organ = () => {
  const [selectedOrgan, setSelectedOrgan] = useState(null);

  const handleOrganClick = (organ) => {
    setSelectedOrgan(organ);
  };

  return (
    <div className="Apporgan">
      <h1>Human Organs for Kids</h1>
      <div className="organs-container">
        {organs.map((organ, index) => (
          <div key={index} className="organ-card" onClick={() => handleOrganClick(organ)}>
            <img src={organ.image} alt={organ.name} />
            <p>{organ.name}</p>
          </div>
        ))}
      </div>
      {selectedOrgan && (
        <div className="organ-details">
          <h2>{selectedOrgan.name}</h2>
          <img src={selectedOrgan.image} alt={selectedOrgan.name} />
          <p>{selectedOrgan.description}</p>
        </div>
      )}
    </div>
  );
};

export default Organ;